export default __webpack_public_path__ + "static/media/work1.7fca31b8.svg";